import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-463f0526"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-category-id"]
const _hoisted_2 = { class: "p-3 bg-white rounded-t-lg border-b flex justify-between items-center" }
const _hoisted_3 = { class: "font-semibold text-gray-700" }
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = {
  class: "py-4 px-6 min-h-[200px] max-h-[calc(100vh-120px)] overflow-y-auto flex flex-col scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100",
  style: {"scrollbar-width":"thin","scrollbar-gutter":"stable","touch-action":"pan-y"}
}
const _hoisted_6 = {
  key: 0,
  class: "p-4 text-gray-400 text-center border border-dashed rounded"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "w-10 h-10 object-contain",
  src: "no-photo.png",
  alt: ""
}
const _hoisted_9 = { class: "font-small text-gray-800 leading-4 line-clamp-2 pb-[1px]" }

import { VueDraggableNext } from "vue-draggable-next";
interface Product {
  id: string;
  name: string;
  display_rank: number;
  category_id: number;
}

interface Category {
  id: string;
  name: string;
  description: string;
  display_rank: string;
  products: Product[];
}


import { productService } from "@/_services";
import {
  defineComponent,
  onMounted,
  defineProps,
  reactive,
  ref,
  defineEmits,
  computed,
  watch,
} from "vue";
import { LeftOutlined,RightOutlined  } from "@ant-design/icons-vue";

const __default__ = defineComponent({
  name: "LbrxCategoryBarItem",
  components: {LeftOutlined,RightOutlined},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    category: {}
  },
  emits: ["update-products", "moveCategory"],
  setup(__props: any, { emit: __emit }) {

const draggable = VueDraggableNext;

const state = reactive({
  category: {} as any,
  products: [] as Product[],
  warehouseId: "",
});

const props = __props;

const emit = __emit;

const getConfig = () => {
  const device = localStorage.getItem("device");
  if (device) {
    const parsedDevice = JSON.parse(device);
    state.warehouseId = JSON.parse(parsedDevice.config).warehouse_id;
  }
};

const getCatProducts = () => {
  productService
    .getProductsByCategory(
      props.category.id,
      "&warehouse_id=" + state.warehouseId
    )
    .then((res) => {
      state.products = res.data;
      //console.log("product cat products", state.products);
    })
    .catch((error) => {
      console.error("error", error);
    });
};

const generateRandom = (length: number) => {
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15) +
    length
  );
};

const affectedProducts = ref<
  Array<{ id: string; category_id: any; display_rank: any }>
>([]);

const onProductDragEnd = (evt: any, categoryId: string) => {
  const { oldIndex, newIndex, from, to, item } = evt;
  //console.log("onProductDragEnd", oldIndex, newIndex, from, to, categoryId);

  const fromCategoryId = from
    .closest(".category-container")
    ?.getAttribute("data-category-id");
  const toCategoryId = to
    .closest(".category-container")
    ?.getAttribute("data-category-id");

  //console.log("from", fromCategoryId, "to", toCategoryId);

  if (fromCategoryId === toCategoryId) {
    if (oldIndex === newIndex) return;

    props.category.products.forEach((product: any, index: any) => {
      const newRank = index + 1;

      // checking if the product is already in affectedProducts
      const existingProductIndex = affectedProducts.value.findIndex(
        (p) => p.id === product.id
      );

      if (existingProductIndex !== -1) {
        affectedProducts.value[existingProductIndex].display_rank = newRank;
      } else {
        affectedProducts.value.push({
          id: product.id,
          category_id: categoryId,
          display_rank: newRank,
        });
      }

      product.display_rank = newRank;
    });
  } else {
    //console.log("products", state.category.products);
    console.log("in catgeory", state.category.id);
  }

  //console.log("Affected products:", affectedProducts.value);
  emit("update-products", affectedProducts.value);
};

watch(
  () => state.category.products,
  (newProducts, oldProducts) => {
    if (oldProducts && oldProducts.length !== newProducts.length) {
      affectedProducts.value = [];
      updateRanks(newProducts);
      //console.log("affected products", affectedProducts.value);
      emit("update-products", affectedProducts.value);
    }
  },
  { deep: true }
);

const updateRanks = (productsArray: []) => {
  productsArray.forEach((product: any, index: any) => {
    const newRank = index + 1;

    // checking if the product is already in affectedProducts
    const existingProductIndex = affectedProducts.value.findIndex(
      (p) => p.id === product.id
    );

    if (existingProductIndex !== -1) {
      affectedProducts.value[existingProductIndex].display_rank = newRank;
    } else {
      affectedProducts.value.push({
        id: product.id,
        category_id: props.category.id,
        display_rank: newRank,
      });
    }

    product.display_rank = newRank;
  });

  //("neeeww affected products", productsArray);
};


const verifyRanks = () => {
  let currentRank = 1;
  props.category.products.forEach((product) => {
    if (product.display_rank === null || product.display_rank === undefined) {
      product.display_rank = currentRank;
    }
    currentRank++;
  });
};

//move items  
const moveLeft=()=>{
  
  emit("moveCategory", props.category.id, "left" );
}


const moveRight=()=>{
  emit("moveCategory", props.category.id, "right" );
}

onMounted(async () => {
  state.category = props.category;
  state.products = [...props.category.products];
});

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex-shrink-0 w-80 bg-gray-50 rounded-lg shadow-sm flex flex-col category-container",
    "data-category-id": _ctx.category.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.category.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "px-3 rounded-md bg-[#f4f4f4]",
          onClick: moveLeft
        }, [
          _createVNode(_unref(LeftOutlined))
        ]),
        _createElementVNode("button", {
          class: "px-3 rounded-md bg-[#f4f4f4]",
          onClick: moveRight
        }, [
          _createVNode(_unref(RightOutlined))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createBlock(_unref(draggable), {
        modelValue: state.category.products,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.category.products) = $event)),
        key: _ctx.category.id + _ctx.category.products.length,
        animation: 200,
        group: { name: 'products' },
        class: "space-y-2",
        onEnd: _cache[1] || (_cache[1] = ($event: any) => (onProductDragEnd($event, _ctx.category.id)))
      }, {
        default: _withCtx(() => [
          (state.category.products?.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('Pos.dargProductTxt')), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.category.products, (product) => {
            return (_openBlock(), _createBlock(_component_a_row, {
              key: product.id,
              gutter: 16,
              class: "bg-white p-3 rounded border shadow-sm hover:shadow-md transition-shadow duration-200 cursor-move px-1 py-1",
              "data-product-id": product.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: { span: 24 },
                  sm: { span: 24 },
                  md: { span: 4 },
                  lg: { span: 5 },
                  xl: { span: 5 },
                  xxl: { span: 5 }
                }, {
                  default: _withCtx(() => [
                    (product.photo!==null)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "w-10 h-10 object-contain",
                          src: product.photo,
                          alt: ""
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true),
                    (product.photo===null)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_a_col, {
                  xs: { span: 24 },
                  sm: { span: 24 },
                  md: { span: 20 },
                  lg: { span: 19 },
                  xl: { span: 19 },
                  xxl: { span: 19 },
                  class: "flex flex-row flex-nowrap justify-start items-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(product.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["data-product-id"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]))
    ])
  ], 8, _hoisted_1))
}
}

})